import { render, staticRenderFns } from "./remark-dialog.vue?vue&type=template&id=1d57fc8d&"
import script from "./remark-dialog.vue?vue&type=script&lang=ts&"
export * from "./remark-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "remark-dialog.vue"
export default component.exports